import logo from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import headerGame from '../Assets/Imgs/Header-Images-Game.jpg';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

function Story() {
  return (
    <div className="App">
      <NavBar />
      <div className="App-header story-header headerGrowing">
        <img src={headerGame} className="header-img headerBGMoving" alt="header" />
        <div className="story-bg info-bg gameHeaderShade">
          <div className="blockWhite" style={{padding:'3%'}}>
            <img src={logo} className="logoInText" />
            <p>
            The Noise Star game is currently in development by Noise Star.<br/>
            It's built in React Native and will be available on Android, and then IOS.<br/>
            <br/>
            Closed Beta in December 2026.
            <br/>
            The game will be released in December 2026.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Story;
